module.exports = __webpack_public_path__ + "media/images/athletes/291-23bb1f0fd17633abfb87c5c5b6e0c269.png";